import { AuthTokens } from "Types/auth";
import { AuthToken } from "config";

export const saveAuthToken = (result: AuthTokens) => {
    localStorage.setItem(AuthToken, JSON.stringify(result));
}
export const removeAuthToken = () => {
    localStorage.removeItem(AuthToken);
}
export const getAuthToken = (): AuthTokens | null => {
    const data = localStorage.getItem(AuthToken);
    if (!data) {
        return null
    }
    try {
        return JSON.parse(data);
    } catch (e) {
        removeAuthToken();
        return null;
    }
}
